// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsRolesPage_pageDescription__Gi3FF"};